






















import { Component, Watch, Vue, Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
})
export default class MarketRules extends Vue {
  @Prop({ default: () => {} }) data: any

  rulesTitle: string = '活动规则'
  isShowModal: boolean = false

  get content() {
    return this.data.content.value
  }

  get url() {
    return this.data.cover.url
  }

  triggleModal() {
    this.isShowModal = !this.isShowModal
    if (this.isShowModal) {
      try {
        this.$el.parentElement.style.zIndex = '1000'
      } catch {}
    } else {
      try {
        this.$el.parentElement.style.zIndex = '994'
      } catch {}
    }
  }
}
